import React from "react";
import AppModal from "../../common/AppModal";
import { Alert } from "@mui/material";
import CreateOrUpdateFiscalItemForm from "../../../forms/CreateOrUpdateFiscalItemForm";

const CreateFiscalItemModal = ({ open, onClose, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    loading={loading}
    title="Fiscalize Local Product"
    width="sm"
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdateFiscalItemForm loading={loading} />
  </AppModal>
);

export default CreateFiscalItemModal;
